import axios from "axios";


const resolveBaseUrl = () => {
  const hostname = window.location.hostname;

  if (hostname === "localhost" || hostname === "127.0.0.1") {
    return "https://omghapi.flockrinc.com/api";
  }

  if (hostname === "corpclaims.oldmutual.com.gh") {
    return "https://be-easylife.oldmutual.com.gh/api";
  }

  return "https://omghapi.flockrinc.com/api";
};


const withApiSuffix = (url) => {
  const trimmed = url.replace(/\/+$/, "");
  return trimmed.endsWith("/api") ? trimmed : `${trimmed}/api`;
};

export const API_BASE_URL = withApiSuffix(resolveBaseUrl());

console.info(`[corp-claims-portal] API base URL: ${API_BASE_URL}`);

const TOKEN_KEY = "corp_claims_portal_token";
const USER_KEY = "corp_claims_portal_user";

export const authStorage = {
  getToken: () => localStorage.getItem(TOKEN_KEY),
  setToken: (t) => localStorage.setItem(TOKEN_KEY, t),
  getUser: () => {
    try {
      return JSON.parse(localStorage.getItem(USER_KEY) || "null");
    } catch {
      return null;
    }
  },
  setUser: (u) => localStorage.setItem(USER_KEY, JSON.stringify(u)),
  clear: () => {
    localStorage.removeItem(TOKEN_KEY);
    localStorage.removeItem(USER_KEY);
  },
};

const client = axios.create({ baseURL: API_BASE_URL });

client.interceptors.request.use((config) => {
  const token = authStorage.getToken();
  if (token) config.headers.Authorization = `Bearer ${token}`;
  return config;
});

client.interceptors.response.use(
  (res) => res,
  (error) => {
    if (error?.response?.status === 401 && !error.config?.url?.includes("/request-otp") && !error.config?.url?.includes("/verify-otp")) {
      authStorage.clear();
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  },
);

/**
 * type: "GET" | "POST" | ... , path relative to /corp-claims/portal,
 * responseType: "json" (default) | "blob" (for the Excel export).
 */
export const portalRequest = async (type, path, data, responseType = "json") => {
  const res = await client.request({
    method: type,
    url: `/corp-claims/portal${path}`,
    data,
    responseType: responseType === "blob" ? "blob" : "json",
  });
  return res.data;
};

export default client;
